import { Profile } from '@/interfaces/profile';
import { profileResource, ProfileResource } from '@/resources/profile.resource';
import { EntityModule } from './entity.module';
import roles from './profile/userRole.module';
/**
 * Moduł profilu
 *
 * @export
 * @class ProfileModule
 * @extends {EntityModule<Profile, ProfileResource>}
 */
export class ProfileModule extends EntityModule<Profile, ProfileResource> {
  /**
   * Submoduły profilu
   *  Wnioski
   *
   * @memberof ProfileModule
   */
  public modules = { roles };

  constructor() {
    super(profileResource);

    this.actions = {
      ...this.actions,

      /**
       * Ustawia dane wnioskodawcy
       *
       * @param {*} context
       * @param {*} data
       * @returns {Promise<number>}
       */
      setApplicantData: (context: any, data: any): Promise<number> => {
        return this.resource.setApplicantData(data);
      }
    };
  }
}

export default new ProfileModule();
